export const LEGAL_LANGUAGE_DA = "da";
export const LEGAL_LANGUAGE_EN = "en";

export function getLegalUiText(language = LEGAL_LANGUAGE_DA) {
  if (language === LEGAL_LANGUAGE_EN) {
    return {
      breadcrumbLabel: "Legal",
      lastUpdatedLabel: "Last updated",
      translationNotice: "The Danish version is the governing version. The English version is provided for convenience only.",
      languageLabels: {
        da: "Dansk",
        en: "English"
      },
      relatedLinks: {
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        cookie: "Cookie Policy"
      }
    };
  }

  return {
    breadcrumbLabel: "Juridisk",
    lastUpdatedLabel: "Sidst opdateret",
    translationNotice: "Den danske version er den gældende version. Den engelske version stilles kun til rådighed som oversættelse.",
    languageLabels: {
      da: "Dansk",
      en: "English"
    },
    relatedLinks: {
      terms: "Brugsvilkår",
      privacy: "Privatlivspolitik",
      cookie: "Cookiepolitik"
    }
  };
}

function TermsOfServiceContentDa() {
  return (
    <>
      <section>
        <h2>1. Operatør og anvendelsesområde</h2>
        <p>
          MyTradeFinder drives af Maximilian Thyrrestrup som privatperson og kan kontaktes på
          max.thyrrestrup@gmail.com. MyTradeFinder er en platform til håndtering af Magic: The Gathering-kortsamlinger,
          ønskelister, trader-lister, kontobeskeder, trade-historik, trade-søgning og relaterede kontoværktøjer.
        </p>
        <p>
          Tjenesten kan udvikle sig over tid. Funktioner kan tilføjes, ændres, suspenderes eller fjernes, når det med
          rimelighed er nødvendigt af hensyn til vedligeholdelse, sikkerhed, produktforbedringer, lovkrav eller misbrugsforebyggelse.
        </p>
      </section>
      <section>
        <h2>2. Konti</h2>
        <p>
          Du skal give korrekte registreringsoplysninger, holde dine loginoplysninger fortrolige og bruge en emailadresse,
          som du selv kontrollerer. Du er ansvarlig for aktivitet, der sker via din konto, medmindre den skyldes et sikkerhedsproblem
          på MyTradeFinders side.
        </p>
        <p>
          Du må ikke udgive dig for at være en anden person, oprette konti til misbrug eller omgåelse af moderation,
          eller forsøge at få adgang til konti, som ikke tilhører dig. MyTradeFinder kan kræve emailverificering,
          før konto-adgang aktiveres.
        </p>
      </section>
      <section>
        <h2>3. Acceptabel brug</h2>
        <p>
          Du må ikke bruge tjenesten til at chikanere andre brugere, sende spam, scrape eller udtrække data i urimeligt omfang,
          undersøge eller angribe platformens sikkerhed, forsøge uautoriseret adgang, forstyrre normal drift eller bruge automatiserede
          metoder på en måde, der overbelaster platformen.
        </p>
        <p>
          Du må ikke uploade eller sende ulovligt, krænkende, svigagtigt, vildledende, truende eller krænkende indhold,
          herunder via beskeder, inventory-noter, want-noter, listings eller andre nuværende eller fremtidige brugerfelter.
        </p>
      </section>
      <section>
        <h2>4. Trades, listings, priser og beskeder</h2>
        <p>
          Listings, værdiansættelser, kortdata, prisvisninger, wants-match og trade-forslag er kun informationsværktøjer.
          MyTradeFinder er ikke part i trades, salg, forsendelser, betalinger, chargebacks, returneringer, ægthedstvister,
          grading-tvister eller forhandlinger mellem brugere.
        </p>
        <p>
          Brugere er selv ansvarlige for at kontrollere kortidentitet, edition, sprog, stand, ægthed, endelig pris,
          forsendelsesmetode, betalingsmetode og om de vil gennemføre en handel med en anden bruger. Platformens beskedfunktion
          stilles kun til rådighed for koordinering og må ikke bruges til misbrug, svindel eller ulovlig adfærd.
        </p>
      </section>
      <section>
        <h2>5. Tredjepartsdata og immaterielle rettigheder</h2>
        <p>
          Kortinformation, set-metadata, billeder og prisreferencer kan komme fra tredjeparter, herunder Scryfall og andre
          markedsdataleverandører, som tjenesten måtte bruge fra tid til anden. Sådanne tredjepartsdata leveres under deres egne vilkår
          og kan være ufuldstændige, forsinkede, rettede eller fjernet.
        </p>
        <p>
          Magic: The Gathering og relaterede navne, kunsthenvisninger og logoer er varemærker eller anden ejendom tilhørende
          Wizards of the Coast LLC og deres respektive ejere. MyTradeFinder er en uafhængig fan-lavet tjeneste og er ikke tilknyttet,
          godkendt af eller sponsoreret af Wizards of the Coast LLC.
        </p>
      </section>
      <section>
        <h2>6. Suspension, lukning og håndhævelse</h2>
        <p>
          MyTradeFinder kan suspendere, begrænse eller lukke konti, når det med rimelighed er nødvendigt for at håndhæve disse vilkår,
          undersøge misbrug, opfylde lovkrav, beskytte brugere, beskytte tjenestens integritet eller håndtere sikkerhedsrisici.
          Det omfatter blandt andet spam, svindel, impersonation, gentagen chikane, scraping eller forsøg på at omgå blokeringer.
        </p>
        <p>
          Hvor det er relevant, kan MyTradeFinder opbevare begrænsede oplysninger om moderation, sikkerhedsrelevante hændelser
          og audit-historik efter suspension eller lukning med henblik på misbrugsforebyggelse, juridisk forsvar og compliance.
        </p>
      </section>
      <section>
        <h2>7. Tilgængelighed, ansvarsfraskrivelse og ansvar</h2>
        <p>
          Tjenesten stilles til rådighed "som den er" og "som tilgængelig" i det omfang loven tillader det. MyTradeFinder garanterer
          ikke uafbrudt tilgængelighed, fejlfri drift, fuldstændig sikkerhed eller nøjagtigheden af tredjepartsdata, prisreferencer
          eller brugerindsendte oplysninger.
        </p>
        <p>
          I det omfang loven tillader det, er MyTradeFinder ikke ansvarlig for indirekte, tilfældige, afledte, særlige, eksemplariske
          eller pønale tab eller skader, eller for tab som følge af brugertvister, mislykkede handler, unøjagtige listings,
          standtvister, nedbrud hos tredjeparter eller platformens nedetid. Intet i disse vilkår udelukker ansvar,
          som ikke lovligt kan udelukkes.
        </p>
      </section>
      <section>
        <h2>8. Ændringer af vilkårene</h2>
        <p>
          MyTradeFinder kan opdatere disse vilkår fra tid til anden for at afspejle nye funktioner, ændringer i lovgivning,
          sikkerhedsbehov eller driftsmæssige forhold. Den seneste versionsdato vises på denne side. Ved væsentlige ændringer
          vil MyTradeFinder søge at give rimeligt varsel via tjenesten, email eller en anden passende kanal.
        </p>
      </section>
      <section>
        <h2>9. Lovvalg og kontakt</h2>
        <p>
          Disse vilkår er underlagt dansk ret, medmindre ufravigelig lokal forbrugerret kræver andet.
          Hvis du har juridiske spørgsmål, supportspørgsmål eller spørgsmål om din konto, kan du kontakte max.thyrrestrup@gmail.com.
        </p>
      </section>
    </>
  );
}

function TermsOfServiceContentEn() {
  return (
    <>
      <section>
        <h2>1. Operator and scope</h2>
        <p>
          MyTradeFinder is operated by Maximilian Thyrrestrup as a private individual and can be reached at
          max.thyrrestrup@gmail.com. MyTradeFinder is a platform for managing Magic: The Gathering card collections,
          want lists, trader lists, account messaging, trade history, trade discovery, and related account tools.
        </p>
        <p>
          The service may evolve over time. Features may be added, changed, suspended, or removed where reasonably
          necessary for maintenance, security, product improvement, legal compliance, or abuse prevention.
        </p>
      </section>
      <section>
        <h2>2. Accounts</h2>
        <p>
          You must provide accurate registration information, keep your login credentials confidential, and use
          an email address you control. You are responsible for activity that takes place through your account
          unless caused by a security issue on MyTradeFinder&apos;s side.
        </p>
        <p>
          You may not impersonate another person, create accounts for abuse or evasion of moderation action,
          or attempt to access accounts that do not belong to you. MyTradeFinder may require email verification
          before account access is activated.
        </p>
      </section>
      <section>
        <h2>3. Acceptable use</h2>
        <p>
          You may not use the service to harass other users, send spam, scrape or extract data at unreasonable
          volume, probe or attack platform security, attempt unauthorized access, interfere with normal service
          operation, or use automated methods in ways that overload the platform.
        </p>
        <p>
          You may not upload or send unlawful, infringing, fraudulent, deceptive, threatening, or abusive content,
          including through messages, inventory notes, want notes, listings, or any future user-generated fields.
        </p>
      </section>
      <section>
        <h2>4. Trades, listings, pricing, and messages</h2>
        <p>
          Listings, valuations, card data, pricing displays, wants matches, and trade suggestions are informational
          tools only. MyTradeFinder is not a party to trades, sales, shipments, payments, chargebacks, returns,
          authenticity disputes, grading disputes, or user-to-user negotiations.
        </p>
        <p>
          Users remain solely responsible for verifying card identity, edition, language, condition, authenticity,
          final price, shipping method, payment method, and whether to complete a transaction with another user.
          Platform messaging is provided for coordination only and may not be used for abuse, fraud, or unlawful conduct.
        </p>
      </section>
      <section>
        <h2>5. Third-party data and intellectual property</h2>
        <p>
          Card information, set metadata, imagery, and pricing references may be sourced from third parties,
          including Scryfall and other market-data providers used by the service from time to time. Such third-party
          data is provided under their own terms and may be incomplete, delayed, corrected, or withdrawn.
        </p>
        <p>
          Magic: The Gathering and related names, artwork references, and logos are trademarks or other property
          of Wizards of the Coast LLC and their respective owners. MyTradeFinder is an independent fan-made service
          and is not affiliated with, endorsed by, or sponsored by Wizards of the Coast LLC.
        </p>
      </section>
      <section>
        <h2>6. Suspension, termination, and enforcement</h2>
        <p>
          MyTradeFinder may suspend, restrict, or terminate accounts where reasonably necessary to enforce these terms,
          investigate abuse, respond to legal obligations, protect users, protect service integrity, or address security risk.
          This includes cases involving spam, fraud, impersonation, repeated harassment, scraping, or attempts to bypass bans.
        </p>
        <p>
          Where appropriate, MyTradeFinder may keep limited records of moderation actions, security-relevant events,
          and audit history after suspension or closure for abuse prevention, legal defense, and compliance purposes.
        </p>
      </section>
      <section>
        <h2>7. Availability, warranty disclaimer, and liability</h2>
        <p>
          The service is provided on an "as available" and "as is" basis to the fullest extent permitted by law.
          MyTradeFinder does not guarantee uninterrupted availability, error-free operation, complete security,
          or the accuracy of third-party data, price references, or user-submitted information.
        </p>
        <p>
          To the fullest extent permitted by law, MyTradeFinder is not liable for indirect, incidental, consequential,
          special, exemplary, or punitive damages, or for losses arising from user disputes, failed trades, inaccurate
          listings, card condition disputes, third-party outages, or platform downtime. Nothing in these terms excludes
          liability that cannot lawfully be excluded.
        </p>
      </section>
      <section>
        <h2>8. Changes to these terms</h2>
        <p>
          MyTradeFinder may update these terms from time to time to reflect new features, changes in law, security needs,
          or business operations. The latest version date will be shown on this page. For material changes, MyTradeFinder
          will seek to provide reasonable notice through the service, by email, or by another appropriate channel.
        </p>
      </section>
      <section>
        <h2>9. Governing law and contact</h2>
        <p>
          These terms are governed by the laws of Denmark, unless mandatory local consumer law requires otherwise.
          If you have legal, support, or account questions, contact max.thyrrestrup@gmail.com.
        </p>
      </section>
    </>
  );
}

function PrivacyPolicyContentDa() {
  return (
    <>
      <section>
        <h2>1. Dataansvarlig</h2>
        <p>
          MyTradeFinder drives af Maximilian Thyrrestrup som privatperson og kan kontaktes på
          max.thyrrestrup@gmail.com. Maximilian Thyrrestrup er dataansvarlig for de personoplysninger,
          der behandles gennem tjenesten, medmindre et specifikt databehandlerforhold eller selvstændigt dataansvar fremgår særskilt.
        </p>
      </section>
      <section>
        <h2>2. Kategorier af personoplysninger</h2>
        <p>
          Afhængigt af hvordan du bruger tjenesten, kan MyTradeFinder behandle konto- og profiloplysninger som brugernavn,
          emailadresse, password-hash, verificeringsstatus, collector tier, kontostatus og tidsstempler knyttet til
          konto-oprettelse, seneste aktivitet og accept af juridiske vilkår.
        </p>
        <p>
          Tjenesten kan også behandle oplysninger om samling, trader-lister, ønskelister, listings, trade-historik og beskeder,
          samt moderation- og audit-oplysninger, som er nødvendige for at undersøge misbrug, hjælpe brugere og administrere platformen.
        </p>
        <p>
          Tekniske oplysninger kan omfatte sessionsidentifikatorer, password-reset- og email-verificeringstokens,
          grundlæggende request-metadata, sikkerhedsrelevante hændelser og lokal browserlagring, der bruges til funktionalitet,
          såsom at huske lokale præferencer eller afviste prompts.
        </p>
      </section>
      <section>
        <h2>3. Formål og behandlingsgrundlag</h2>
        <p>
          MyTradeFinder behandler personoplysninger for at oprette og administrere konti, autentificere brugere,
          opretholde sessioner, levere samlings- og trade-relateret funktionalitet, formidle kontobeskeder,
          understøtte moderation, svare på supporthenvendelser og beskytte tjenestens sikkerhed og integritet.
        </p>
        <p>
          Behandlingsgrundlaget er typisk opfyldelse af aftale for kernefunktioner, legitim interesse for sikkerhed,
          drift, misbrugsforebyggelse og moderation, samt retlig forpligtelse hvor opbevaring, videregivelse eller håndtering
          følger af lovgivning. Hvis der senere tilføjes samtykkebaseret analytics, marketing eller lignende teknologier,
          bør MyTradeFinder dokumentere dette og indhente relevant samtykke før aktivering.
        </p>
      </section>
      <section>
        <h2>4. Deling og databehandlere</h2>
        <p>
          Personoplysninger sælges ikke. Oplysninger kan deles med infrastruktur- og tjenesteleverandører,
          der hjælper med at drive MyTradeFinder, såsom hostingudbydere, databasedrift, emaillevering,
          sikkerhedsværktøjer og deploy-platforme.
        </p>
        <p>
          De nuværende leverandører omfatter Vercel til frontend-hosting, Railway til backend-hosting,
          Railway til database-hosting og Resend til transaktionsmails. Adgang begrænses til det,
          der med rimelighed er nødvendigt for at drive, sikre, vedligeholde og supportere tjenesten.
        </p>
      </section>
      <section>
        <h2>5. Opbevaring</h2>
        <p>
          Kontooplysninger opbevares som udgangspunkt, så længe kontoen er aktiv, og i en begrænset periode derefter,
          når det er nødvendigt af hensyn til uenigheder, juridisk forsvar, misbrugsforebyggelse eller legitime driftsmæssige registreringer.
        </p>
        <p>
          Email-verificeringstokens udstedes med op til 24 timers gyldighed, og password-reset-tokens udstedes med op til 2 timers gyldighed.
          Verificerings- og reset-tokens opbevares kun i deres aktive sikkerhedslivscyklus eller i korte opfølgningsperioder.
          Beskeder, trade-historik, moderationslogs og admin-audit-records kan opbevares længere, når det er nødvendigt
          for at bevare historik, undersøge misbrug, dokumentere administrative handlinger eller overholde lovkrav.
        </p>
        <p>
          Når oplysninger ikke længere er nødvendige til disse formål, bør de slettes, anonymiseres eller begrænses,
          afhængigt af hvilken type data der er tale om, og hvilke sikkerheds- eller dokumentationshensyn der gør sig gældende.
        </p>
      </section>
      <section>
        <h2>6. Cookies og lokal lagring</h2>
        <p>
          MyTradeFinder bruger en nødvendig session-cookie til autentificering og kan bruge begrænset lokal browserlagring
          til funktionel produktadfærd. Detaljer findes i Cookiepolitikken. På offentlige sider kan MyTradeFinder også,
          når brugeren giver samtykke gennem Googles European regulations message og tilhørende privacy-valg,
          bruge Google AdSense og relaterede reklamecookies eller lignende teknologier til levering,
          begrænset måling og styring af annoncer.
        </p>
      </section>
      <section>
        <h2>7. Dine rettigheder</h2>
        <p>
          Afhængigt af din jurisdiktion kan du have ret til indsigt, berigtigelse, sletning, begrænsning, indsigelse
          eller dataportabilitet, samt ret til at klage til en tilsynsmyndighed. Når MyTradeFinder drives fra Danmark,
          vil den relevante tilsynsmyndighed som udgangspunkt være Datatilsynet, uden at det begrænser eventuelle rettigheder
          til at kontakte en anden kompetent myndighed, hvis det er relevant. Nogle rettigheder kan være begrænsede,
          hvis data skal opbevares af hensyn til sikkerhed, lovkrav, svindelforebyggelse eller forsvar af retskrav.
        </p>
        <p>
          Henvendelser om rettigheder, kontodata eller sletning skal sendes til max.thyrrestrup@gmail.com.
          For at beskytte konti og personoplysninger kan MyTradeFinder bede dig bekræfte kontrol over den registrerede
          emailadresse eller på anden rimelig måde bekræfte din identitet, før anmodningen behandles.
        </p>
      </section>
      <section>
        <h2>8. Internationale overførsler og sikkerhed</h2>
        <p>
          Hvis personoplysninger behandles uden for brugerens hjemjurisdiktion, bør MyTradeFinder støtte sig på et passende
          retligt overførselsgrundlag, hvor det er nødvendigt, såsom adequacy-beslutninger, kontraktuelle garantier
          eller et andet lovligt grundlag. Tjenesten bruger i øjeblikket Vercel, Railway og Resend som infrastruktur- og
          kommunikationsleverandører, og eventuelle overførselskrav bør vurderes i forhold til disse leverandørers lokationer
          og retlige rammer.
        </p>
        <p>
          MyTradeFinder anvender rimelige tekniske og organisatoriske sikkerhedsforanstaltninger til beskyttelse af personoplysninger,
          herunder password-hashing, autentificeringskontroller, kontoverificering og driftsmæssige sikkerhedsforanstaltninger,
          der passer til tjenestens karakter. Ingen internetforbundet løsning kan garanteres fuldstændigt sikker.
        </p>
      </section>
      <section>
        <h2>9. Ændringer af denne politik</h2>
        <p>
          MyTradeFinder kan opdatere denne politik for at afspejle ændringer i funktioner, drift, lovgivning eller leverandører.
          Den seneste versionsdato vil fremgå af denne side. Ved væsentlige ændringer bør MyTradeFinder give rimeligt varsel
          via tjenesten, email eller en anden passende kanal.
        </p>
      </section>
    </>
  );
}

function PrivacyPolicyContentEn() {
  return (
    <>
      <section>
        <h2>1. Data controller</h2>
        <p>
          MyTradeFinder is operated by Maximilian Thyrrestrup as a private individual and can be reached at
          max.thyrrestrup@gmail.com. Maximilian Thyrrestrup is the controller for the personal data processed through the service,
          except where a specific processor or independent controller relationship is stated otherwise.
        </p>
      </section>
      <section>
        <h2>2. Categories of personal data</h2>
        <p>
          Depending on how you use the service, MyTradeFinder may process account and profile data such as username,
          email address, password hash, verification status, collector tier, account status, and timestamps related
          to account creation, recent activity, and acceptance of legal terms.
        </p>
        <p>
          The service may also process collection, trader, want-list, listing, trade-history, and messaging data,
          together with moderation and audit information needed to investigate abuse, support users, and administer the platform.
        </p>
        <p>
          Technical data may include session identifiers, password-reset and email-verification tokens, basic request metadata,
          security-relevant events, and local device storage used for product functionality such as remembering local preferences
          or dismissed prompts.
        </p>
      </section>
      <section>
        <h2>3. Purpose and legal basis</h2>
        <p>
          MyTradeFinder processes personal data to create and manage accounts, authenticate users, maintain sessions,
          enable collection and trade-related functionality, transmit account messages, operate moderation workflows,
          respond to support requests, and protect service security and integrity.
        </p>
        <p>
          The legal basis is generally contract performance for core account and platform features, legitimate interests
          for security, product administration, abuse prevention, and moderation, and legal obligation where retention,
          disclosure, or handling is required by applicable law. If optional analytics, marketing, or other consent-based
          technologies are added later, MyTradeFinder should document and request consent for them before activation.
        </p>
      </section>
      <section>
        <h2>4. Sharing and processors</h2>
        <p>
          Personal data is not sold. Data may be shared with infrastructure and service providers that help operate
          MyTradeFinder, such as hosting providers, managed databases, email delivery services, security tools, and
          deployment platforms.
        </p>
        <p>
          The current providers used by the app include Vercel for frontend hosting, Railway for backend hosting,
          Railway for database hosting, and Resend for transactional email delivery. Access is limited to what is
          reasonably necessary to operate, secure, maintain, and support the service.
        </p>
      </section>
      <section>
        <h2>5. Retention</h2>
        <p>
          Account data is generally retained for as long as the account remains active and for a limited period afterward
          where needed for dispute handling, legal defense, abuse prevention, or legitimate business records.
        </p>
        <p>
          Email verification tokens are issued with up to 24 hours of validity, and password reset tokens are issued with up to
          2 hours of validity. Verification and reset tokens are retained only for their active security lifecycle or short
          follow-up periods.
          Messages, trade history, moderation logs, and admin audit records may be retained longer where needed to preserve
          account history, investigate abuse, document staff actions, or comply with legal obligations.
        </p>
        <p>
          When data is no longer needed for those purposes, it should be deleted, anonymized, or restricted as appropriate
          for the type of data involved and the security or documentation needs at issue.
        </p>
      </section>
      <section>
        <h2>6. Cookies and local storage</h2>
        <p>
          MyTradeFinder uses a necessary session cookie for authentication and may use limited local storage for functional
          product behavior. Details are described in the Cookie Policy. On public pages, MyTradeFinder may also, where the
          user provides consent through Google's European regulations message and related privacy choices,
          use Google AdSense and related advertising cookies or similar technologies for ad delivery,
          limited measurement, and ad control.
        </p>
      </section>
      <section>
        <h2>7. Your rights</h2>
        <p>
          Depending on your jurisdiction, you may have rights to access, correct, delete, restrict, object to, or receive
          a copy of your personal data, and to complain to a supervisory authority. When MyTradeFinder is operated from Denmark,
          the relevant supervisory authority will generally be Datatilsynet, without limiting any rights you may have to contact
          another competent authority where applicable. Some rights may be limited where data must be kept for security,
          legal compliance, fraud prevention, or the defense of legal claims.
        </p>
        <p>
          Requests regarding privacy rights, account data, or deletion should be sent to max.thyrrestrup@gmail.com.
          To protect accounts and personal data, MyTradeFinder may ask you to confirm control of the registered email address
          or otherwise verify your identity by reasonable means before the request is processed.
        </p>
      </section>
      <section>
        <h2>8. International transfers and security</h2>
        <p>
          If personal data is processed outside the user&apos;s home jurisdiction, MyTradeFinder should rely on an appropriate
          legal transfer mechanism where required, such as adequacy decisions, contractual safeguards, or another lawful basis.
          The service currently relies on Vercel, Railway, and Resend as infrastructure and communications providers, and
          any required transfer mechanism should be assessed against the locations and legal frameworks used by those providers.
        </p>
        <p>
          MyTradeFinder uses reasonable technical and organizational measures to protect personal data, including password hashing,
          authentication controls, account verification flows, and operational security measures appropriate to the service.
          No internet-connected system can be guaranteed completely secure.
        </p>
      </section>
      <section>
        <h2>9. Changes to this policy</h2>
        <p>
          MyTradeFinder may update this policy to reflect feature changes, operational changes, legal developments,
          or provider changes. The latest version date will be displayed on this page. For material changes,
          MyTradeFinder will seek to provide reasonable notice through the service, by email, or by another appropriate channel.
        </p>
      </section>
    </>
  );
}

function CookiePolicyContentDa() {
  return (
    <>
      <section>
        <h2>1. Nødvendig autentificeringscookie</h2>
        <p>
          MyTradeFinder sætter en førstepartscookie med navnet mtg_session. Den bruges til at holde autentificerede brugere logget ind,
          forbinde anmodninger med den aktuelle kontosession, beskytte konto-adgang og understøtte sikker drift af appen.
        </p>
        <p>
          Denne cookie er nødvendig for kernefunktionalitet og bruges ikke til reklameformål. I den nuværende implementering
          er den konfigureret med sikkerhedsfokuseret adfærd, herunder HttpOnly- og SameSite-beskyttelse. I produktion bør
          transportsikkerhedsindstillingerne afspejle det faktiske deploy-miljø.
        </p>
      </section>
      <section>
        <h2>2. Lokal lagring og lignende browserlagring</h2>
        <p>
          Applikationen kan bruge begrænset browserlagring til funktionelle præferencer, for eksempel afviste prompts
          eller andre lokale indstillinger. Samtykke til annoncer på offentlige sider håndteres gennem Googles
          European regulations message og tilhørende privacy-valg frem for gennem et separat lokalt annoncebanner.
        </p>
        <p>
          Hvis der senere indføres yderligere præferencelagring, såsom huskede UI-indstillinger eller valgfri bekvemmelighedsfunktioner,
          bør denne politik opdateres, før sådan lagring aktiveres i produktion.
        </p>
      </section>
      <section>
        <h2>3. Nuværende cookieoversigt</h2>
        <p>
          Baseret på den nuværende implementering bruger MyTradeFinder følgende:
        </p>
        <p>
          Cookie eller lagring: mtg_session og begrænset lokal lagring til funktionelle præferencer.<br />
          Formål: autentificering, kontosikkerhed og produktfunktionalitet.<br />
          Type: førsteparts funktionel eller strengt nødvendig lagring.<br />
          Opbevaring: mtg_session sættes i den nuværende implementering med op til 30 dages levetid. Præference-relateret lokal lagring
          bevares typisk, indtil brugeren rydder browserdata eller appen fjerner den gemte værdi.
        </p>
        <p>
          Hvis brugeren accepterer annoncer, kan Google AdSense desuden sætte eller læse reklamerelaterede cookies eller lignende
          teknologier på offentlige sider i overensstemmelse med Googles egne systemer og gældende samtykkeregler.
          Håndtering af disse annoncevalg sker gennem Googles European regulations message og de privacy-indstillinger,
          som Google stiller til rådighed for brugeren.
        </p>
      </section>
      <section>
        <h2>4. Reklamecookies kræver samtykke</h2>
        <p>
          Google AdSense på offentlige sider er underlagt brugerens samtykkevalg gennem Googles European regulations message.
          Hvis samtykke ikke gives, vil Google håndtere annonceringen i overensstemmelse med det valgte eller manglende samtykke.
        </p>
      </section>
      <section>
        <h2>5. Håndtering af cookies</h2>
        <p>
          Browserindstillinger kan som regel bruges til at blokere eller slette cookies, men det kan forhindre login
          og andre kernefunktioner i at virke korrekt.
        </p>
        <p>
          For reklamevalg på offentlige sider bør brugeren bruge Googles privacy- og samtykkeindstillinger, når de vises som en del
          af European regulations message eller relaterede privacy-kontroller.
        </p>
      </section>
      <section>
        <h2>6. Leverandører og kontakt</h2>
        <p>
          Cookie-relaterede data kan blive behandlet gennem de leverandører, der bruges til at hoste og drive tjenesten,
          herunder Vercel til frontend-hosting, Railway til backend- og databaseinfrastruktur og Google i forbindelse med
          levering af AdSense-annoncer, hvis brugeren giver samtykke.
        </p>
        <p>
          Spørgsmål om cookies eller browserlagring kan sendes til max.thyrrestrup@gmail.com.
        </p>
      </section>
    </>
  );
}

function CookiePolicyContentEn() {
  return (
    <>
      <section>
        <h2>1. Necessary authentication cookie</h2>
        <p>
          MyTradeFinder sets a first-party cookie named mtg_session. It is used to keep authenticated users signed in,
          associate requests with the current account session, protect account access, and support secure operation of the app.
        </p>
        <p>
          This cookie is necessary for core functionality and is not used for advertising. In the current implementation,
          it is configured for security-focused behavior including HttpOnly and SameSite protections. In production,
          transport security settings should also reflect the deployed environment.
        </p>
      </section>
      <section>
        <h2>2. Local storage and similar browser storage</h2>
        <p>
          The application may use limited browser storage for functional preferences such as dismissing certain prompts.
          Consent for advertising on public pages is handled through Google's European regulations message and related privacy
          choices rather than through a separate local advertising banner.
        </p>
        <p>
          If additional preference storage is introduced later, such as remembered UI settings or optional convenience features,
          this policy should be updated before that storage is enabled in production.
        </p>
      </section>
      <section>
        <h2>3. Current cookie summary</h2>
        <p>
          Based on the current implementation, MyTradeFinder uses:
        </p>
        <p>
          Cookie or storage item: mtg_session and limited local storage for functional preferences.<br />
          Purpose: authentication, account security, and product functionality.<br />
          Type: first-party functional or strictly necessary storage.<br />
          Retention: in the current implementation, mtg_session is set with up to a 30-day lifetime. Preference-related local storage
          will typically remain until the user clears browser data or the app removes the stored item.
        </p>
        <p>
          If the user accepts advertising, Google AdSense may also set or read advertising-related cookies or similar technologies
          on public pages in accordance with Google's systems and applicable consent requirements. Management of those advertising
          choices is handled through Google's European regulations message and the privacy controls Google makes available.
        </p>
      </section>
      <section>
        <h2>4. Advertising cookies require consent</h2>
        <p>
          Google AdSense on public pages is subject to the user's consent choices through Google's European regulations message.
          If consent is not granted, Google will handle advertising behavior in accordance with the chosen or missing consent state.
        </p>
      </section>
      <section>
        <h2>5. Managing cookies</h2>
        <p>
          Browser settings can usually be used to block or delete cookies, but doing so may prevent sign-in and other
          core features from working correctly.
        </p>
        <p>
          For advertising choices on public pages, users should use Google's privacy and consent controls when shown as part of the
          European regulations message or related privacy options.
        </p>
      </section>
      <section>
        <h2>6. Providers and contact</h2>
        <p>
          Cookie-related data may be processed through the providers used to host and operate the service, including
          Vercel for frontend hosting, Railway for backend and database infrastructure, and Google in connection with
          AdSense ad delivery if the user gives consent.
        </p>
        <p>
          Questions about cookies or browser storage should be sent to max.thyrrestrup@gmail.com.
        </p>
      </section>
    </>
  );
}

export function getTermsDocument(language = LEGAL_LANGUAGE_DA) {
  if (language === LEGAL_LANGUAGE_EN) {
    return {
      title: "Terms of Service",
      lastUpdated: "April 26, 2026",
      intro: "These terms govern access to and use of MyTradeFinder. They explain what the service does, what users may and may not do on the platform, and how responsibility is allocated between MyTradeFinder and its users.",
      content: <TermsOfServiceContentEn />
    };
  }

  return {
    title: "Brugsvilkår",
    lastUpdated: "26. april 2026",
    intro: "Disse vilkår regulerer adgang til og brug af MyTradeFinder. De beskriver, hvad tjenesten gør, hvad brugere må og ikke må på platformen, og hvordan ansvaret fordeles mellem MyTradeFinder og dets brugere.",
    content: <TermsOfServiceContentDa />
  };
}

export function getPrivacyDocument(language = LEGAL_LANGUAGE_DA) {
  if (language === LEGAL_LANGUAGE_EN) {
    return {
      title: "Privacy Policy",
      lastUpdated: "August 21, 2026",
      intro: "This policy explains what personal data MyTradeFinder processes, why it is processed, who it may be shared with, and how long it is retained.",
      content: <PrivacyPolicyContentEn />
    };
  }

  return {
    title: "Privatlivspolitik",
    lastUpdated: "21. august 2026",
    intro: "Denne politik forklarer, hvilke personoplysninger MyTradeFinder behandler, hvorfor de behandles, hvem de eventuelt deles med, og hvor længe de opbevares.",
    content: <PrivacyPolicyContentDa />
  };
}

export function getCookieDocument(language = LEGAL_LANGUAGE_DA) {
  if (language === LEGAL_LANGUAGE_EN) {
    return {
      title: "Cookie Policy",
      lastUpdated: "August 21, 2026",
      intro: "This page describes the cookies and similar technologies currently used by MyTradeFinder. Based on the current codebase, the service uses a necessary authentication cookie and limited functional local storage.",
      content: <CookiePolicyContentEn />
    };
  }

  return {
    title: "Cookiepolitik",
    lastUpdated: "21. august 2026",
    intro: "Denne side beskriver de cookies og lignende teknologier, som MyTradeFinder bruger i øjeblikket. Baseret på den nuværende kodebase bruger tjenesten en nødvendig autentificeringscookie og begrænset funktionel lokal lagring.",
    content: <CookiePolicyContentDa />
  };
}